"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.InputBase = exports.InputAdornment = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('form')((param)=>{
    let { theme } = param;
    return {
        padding: theme.spacing(0, 3, 8),
        textAlign: 'center'
    };
});
const InputAdornment = exports.InputAdornment = (0, _mui.styled)(_mui.InputAdornment)((param)=>{
    let { theme } = param;
    return {
        ["&.".concat(_mui.inputAdornmentClasses.positionEnd)]: {
            color: theme.palette.grey[300],
            padding: theme.spacing(1),
            margin: theme.spacing(-1),
            '& button': {
                padding: theme.spacing(0, 2)
            },
            '& button:hover': {
                backgroundColor: 'transparent'
            }
        },
        ["&.".concat(_mui.inputAdornmentClasses.positionStart)]: {
            color: theme.palette.text.primary,
            padding: theme.spacing(0, 1, 0, 3),
            cursor: 'pointer'
        }
    };
});
const InputBase = exports.InputBase = (0, _mui.styled)(_mui.InputBase)((param)=>{
    let { theme } = param;
    return {
        input: {
            color: theme.palette.text.primary,
            fontFamily: [
                'SansOri',
                'Arial',
                'Helvetica',
                'sans-serif'
            ].join(','),
            fontSize: '1.4rem',
            lineHeight: 1,
            padding: theme.spacing(2, 0),
            width: '100%',
            textFillColor: theme.palette.text.primary
        },
        ["&.".concat(_mui.inputBaseClasses.root)]: {
            width: '100%',
            [theme.breakpoints.up('md')]: {
                width: '600px'
            },
            backgroundColor: theme.palette.grey[100],
            border: "2px solid ".concat(theme.palette.grey[100]),
            borderRadius: '22.5px'
        }
    };
});
